import { lazyGovern, GovernPriority } from 'owa-tti';
import { lazyShouldLoadEmbedPreAuthOnIdle, lazyGetChatUnreadMessageCount } from '../lazyFunctions';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isCapabilityEnabled } from 'owa-capabilities';
import { headerTeamsChatCapability } from 'owa-capabilities-definitions/lib/headerTeamsChatCapability';
import { shouldMakeCallToGetChatUnreadMessageCount } from './shouldLoadPreAuthOnIdle';

let isShouldLoadPreAuthComputed: boolean = false;
let isUnreadChatCountComputed: boolean = false;
let shouldLoadPreAuthOnIdleResult: boolean = false;
let unreadChatCount: number = 0;

export const shouldLoadPreAuthOnIdleCallbackPromise: Promise<boolean> = new Promise<boolean>(
    (resolve, reject) => {
        if (!isShouldLoadPreAuthComputed) {
            lazyGovern.importAndExecute({
                task: async () => {
                    try {
                        shouldLoadPreAuthOnIdleResult =
                            isFeatureEnabled('fwk-teamsSDKPreAuth') &&
                            isCapabilityEnabled(headerTeamsChatCapability)
                                ? await lazyShouldLoadEmbedPreAuthOnIdle.importAndExecute()
                                : false;
                        isShouldLoadPreAuthComputed = true;
                        resolve(shouldLoadPreAuthOnIdleResult);
                    } catch (error) {
                        reject(error);
                    }
                },
                priority: GovernPriority.Idle,
                name: 'shouldLoadPreAuthOnIdleCallbackPromise',
            });
        } else {
            resolve(shouldLoadPreAuthOnIdleResult);
        }
    }
);

export const getChatUnreadMessageCallbackPromise: Promise<number> = new Promise<number>(
    (resolve, reject) => {
        if (!isUnreadChatCountComputed) {
            lazyGovern.importAndExecute({
                task: async () => {
                    try {
                        const shouldGetChats =
                            isCapabilityEnabled(headerTeamsChatCapability) &&
                            shouldMakeCallToGetChatUnreadMessageCount();
                        unreadChatCount = shouldGetChats
                            ? await lazyGetChatUnreadMessageCount.importAndExecute()
                            : 0;
                        isUnreadChatCountComputed = true;
                        resolve(unreadChatCount);
                    } catch (error) {
                        reject(error);
                    }
                },
                priority: GovernPriority.Idle,
                name: 'getChatUnreadMessageCallbackPromise',
            });
        } else {
            resolve(unreadChatCount);
        }
    }
);
